/* Одна строка: перенос чипов растил шапку варианта вверх. Не влезшее уезжает
   в горизонтальную прокрутку контейнера в шапке. */
.summary {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: var(--sp-2);
  width: max-content;
  min-width: 0;
}

/* Высоту задаёт шапка варианта — чипы должны стоять вровень с её кнопками. */
.chip {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  height: var(--hdr-ctl-h, 28px);
  padding: 0 var(--sp-3);
  background: var(--surface);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  color: var(--text-2);
  font-size: var(--fs-xs);
  line-height: 1;
  white-space: nowrap;
}

/* Маршрут — самая содержательная часть сводки, поэтому контрастнее остальных чипов. */
.route {
  color: var(--text);
}
